const $style = document.createElement('style');
document.head.appendChild($style);

export default class {
  constructor(parent) {
    this.parent = parent;
  }

  get data() {
    return `${
      this.getHideNationalPriceInAgreementHeader()
    }${
      this.getHideNationalPriceInRequest()
    }`;
  }

  getHideNationalPriceInRequest() {
    return this.get('HideNationalPriceInRequest')
      ? 'body .cost_cur_order_middle_r{display: none;}body .cost_cur_order_middle_l_inner{margin:0;}'
      : '';
  }

  getHideNationalPriceInAgreementHeader() {
    return this.get('HideNationalPriceInAgreementHeader')
      ? '.form-group-agreement{display: none!important;}'
      : '';
  }

  init() {
    $style.innerHTML = this.data;
  }

  get(key) {
    return this.parent.get(key);
  }
}
